// extracted by mini-css-extract-plugin
export var alert = "layout-module--alert--6OaoQ";
export var alertText = "layout-module--alert-text--cljpJ";
export var alertTextLink = "layout-module--alert-text-link--K15Jo";